import { useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, Circle, Rocket, X, ArrowRight } from "lucide-react";
import { Panel } from "@/components/core/AppLayout";
import { Progress } from "@/components/ui/progress";
import { api } from "@/lib/api";
import { useFetch } from "@/lib/hooks";

export const OnboardingCard = () => {
  const { data, setData, reload } = useFetch("/onboarding");
  useEffect(() => {
    window.addEventListener("focus", reload);
    window.addEventListener("core-clients-changed", reload);
    return () => { window.removeEventListener("focus", reload); window.removeEventListener("core-clients-changed", reload); };
  }, [reload]);
  if (!data || data.nascosta || data.completata) return null;
  const done = data.passi.filter((p) => p.fatto).length;
  const hide = async () => { setData((await api.put("/onboarding", { nascosta: true })).data); toast.success("Guida nascosta: puoi riaprirla dal tuo Profilo"); };
  return (
    <Panel className="p-4 sm:p-6 mb-8 core-rise border-2 border-[#0A1128]/15" data-testid="onboarding-card">
      <div className="flex flex-col sm:flex-row items-start justify-between gap-3 sm:gap-4 mb-4">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-2xl bg-[#E8173A] text-white flex items-center justify-center"><Rocket className="h-5 w-5" /></div>
          <div><div className="font-display text-xl font-black text-[#0A1128]">Primi passi con Core</div>
            <div className="text-sm text-slate-600">{done} di {data.passi.length} completati · si spuntano da soli man mano che usi l'app.</div></div>
        </div>
        <button onClick={hide} className="text-sm font-bold text-slate-600 hover:text-[#E8173A] inline-flex items-center gap-1" data-testid="onboarding-hide"><X className="h-4 w-4" />Nascondi guida</button>
      </div>
      <Progress value={(done / data.passi.length) * 100} className="h-2 mb-4" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {data.passi.map((p) => (
          <Link key={p.key} to={p.key === "cliente" && !p.fatto ? "/clienti?importa=1" : p.link} className={`group flex items-center gap-3 rounded-xl px-4 py-3 transition-colors ${p.fatto ? "bg-white/50" : "bg-[#A6DAFC] hover:bg-[#8FD0FB]"}`} data-testid={`onboarding-step-${p.key}`}>
            {p.fatto ? <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" /> : <Circle className="h-5 w-5 text-[#0A1128]/40 shrink-0" />}
            <div className="min-w-0 flex-1"><div className={`font-bold text-sm ${p.fatto ? "text-slate-500 line-through" : "text-[#0A1128]"}`}>{p.titolo}</div><div className="text-xs text-slate-600 truncate">{p.testo}</div></div>
            {!p.fatto && <ArrowRight className="h-4 w-4 text-[#0A1128] group-hover:translate-x-0.5 transition-transform" />}
          </Link>
        ))}
      </div>
    </Panel>
  );
};

export const OnboardingReopen = () => {
  const { data, setData } = useFetch("/onboarding");
  if (!data || !data.nascosta) return null;
  const show = async () => { setData((await api.put("/onboarding", { nascosta: false })).data); toast.success("Guida «Primi passi» di nuovo visibile in Dashboard"); };
  return <button onClick={show} className="mt-4 text-sm font-bold text-[#0A1128] hover:text-[#E8173A] inline-flex items-center gap-1.5" data-testid="onboarding-reopen"><Rocket className="h-4 w-4" />Mostra di nuovo la guida «Primi passi»</button>;
};
